import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  formatCost,
  NOT_AVAILABLE_DEFAULT_STR,
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

export class CurrentCostColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, isOptimizationScoreOn, recommendationType }) {
    const title = i18n.getString('Recommendation_ColumnName_PreviousSpend');
    const helpId = recommendationType === RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION ?
      'pop_BA_Recommendations_RSA_PrevWeeklySpendCamp' : 'Pop_BA_Recommendations_RSA_PrevWeeklySpend';
    super({
      name: 'CurrentCost',
      property: 'CurrentCost',
      title,
      bodyClasses: ['grid-column-currentCost', isOptimizationScoreOn ? 'with-optimization-score' : ''],
      colClasses: ['col-number'],
      sortable: true,
      helpId,
      type: 'number',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
  }

  template({ value: { CurrentCost } }) {
    const { i18n } = this;
    return _.isNumber(CurrentCost) ?
      formatCost(CurrentCost, i18n, i18n.currency) : NOT_AVAILABLE_DEFAULT_STR;
  }

  get property() {
    return {
      get: _.identity,
      key: 'CurrentCost',
    };
  }
}
